import Moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Button,
  CircularProgress,
  Typography,
  Grid,
  AppBar,
  Tabs,
  Tab,
} from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
// import { useSnackbar } from 'notistack';
import { withSnackbar } from 'notistack';
import { fetchPatientById } from '../../services/api';

import TabPanel from '../../components/TabPanel';

import PatientProfile from '../ProviderAdminPatients/components/PatientProfile';
import BookAppointmentModal from '../ProviderAdminPatients/components/BookAppointmentModal';
import ConsultNoteEditModal from '../../components/ConsultNoteEditModal';
import PatientChartConsultNotes from '../../components/PatientChartConsultNotes';
import PatientChartApptReqs from '../../components/PatientChartApptReqs';
import PatientTracker from '../../components/PatientTracker';
import PatientChartAppts from '../../components/PatientChartAppts';
import PatientsAttachments from '../../components/PatientsAttachments';

import { createConsultNote, updatePatient } from '../../services/api';
import './style.css';

const { standardizePhoneNumber } = require('../../util/standardizePhoneNumber');

const userInfoForm = ({
  classes,
  firstName,
  lastName,
  phone,
  email,
  birthdate,
  gender,
  zipcode,
  guardians,
  dependents,
  insuranceId,
  insuranceName,
  groupProvider,  
  isConciergePatient,
  conciergeProvider,
  tebraPatientId,
}) => (
  <>
    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Name</h4>
      <span className={classes.panelDetailsSectionText}>{firstName}</span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Lastname</h4>
      <span className={classes.panelDetailsSectionText}>{lastName}</span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Email</h4>
      {/* <span className={classes.panelDetailsSectionText}>{email.includes('@example.com') ? '--' : email}</span> */}
      <span className={classes.panelDetailsSectionText}>{email}</span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Phone</h4>
      <span className={classes.panelDetailsSectionText}>
        {standardizePhoneNumber(phone) || '--'}
      </span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Zip Code</h4>
      <span className={classes.panelDetailsSectionText}>{zipcode || '--'}</span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Sex</h4>
      <span className={classes.panelDetailsSectionText}>{gender}</span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>DOB</h4>
      <span className={classes.panelDetailsSectionText}>
        {birthdate ? Moment.utc(birthdate).format('MM/DD/YYYY') : null}
      </span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>PATIENT TEBRA ID</h4>
      <span className={classes.panelDetailsSectionText}>
        {tebraPatientId || '--'}
      </span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Insurance Name</h4>
      <span className={classes.panelDetailsSectionText}>
        {insuranceName || '--'}
      </span>
    </div>

    <div className={classes.panelDetailsSection}>
      <h4 className={classes.panelDetailsSectionTitle}>Insurance Id</h4>
      <span className={classes.panelDetailsSectionText}>
        {insuranceId || '--'}
      </span>
    </div>

    {isConciergePatient && (
      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>
          Qwell Concierge Member Of
        </h4>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {conciergeProvider.map((conciergeProviders,index) => (
            <span className={classes.panelDetailsSectionText} key={index}>
              {conciergeProviders.provider.user.userJoinName}
              {index < conciergeProvider.length - 1 && ", "}
            </span>
          ))}
        </div>
      </div>
    )}

    {guardians.length > 0 && (
      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>{`Family member${
          guardians.length > 1 ? 's' : ''
        }`}</h4>
        <div style={{ display: 'flex' }}>
          {guardians.map(guardian => (
            <span className={classes.panelDetailsSectionText}>
              {guardian.name}&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    )}

    {guardians.length > 0 && (
      <div className={classes.panelDetailsSection}>
        <h4
          className={classes.panelDetailsSectionTitle}
        >{`Family member Emailid${guardians.length > 1 ? 's' : ''}`}</h4>
        <div style={{ display: 'flex' }}>
          {guardians.map(guardian => (
            <span className={classes.panelDetailsSectionText}>
              {guardian.email}&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    )}
    {guardians.length > 0 && (
      <div className={classes.panelDetailsSection}>
        <h4
          className={classes.panelDetailsSectionTitle}
        >{`Family Member Phone Number${guardians.length > 1 ? 's' : ''}`}</h4>
        <div style={{ display: 'flex' }}>
          {guardians.map(guardian => (
            <span className={classes.panelDetailsSectionText}>
              {guardian.phone}&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    )}
    {dependents.length > 0 && (
      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>{`Family child member${
          dependents.length > 1 ? 's' : ''
        }`}</h4>
        <div style={{ display: 'flex' }}>
          {dependents.map(dependent => (
            <span className={classes.panelDetailsSectionText}>
              {dependent.name}&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    )}

    {dependents.length > 0 && (
      <div className={classes.panelDetailsSection}>
        <h4
          className={classes.panelDetailsSectionTitle}
        >{`Family child member Emailid${dependents.length > 1 ? 's' : ''}`}</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {dependents.map(dependent => (
            <span className={classes.panelDetailsSectionText}>
              {dependent.email}&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    )}
    {dependents.length > 0 && (
      <div className={classes.panelDetailsSection}>
        <h4
          className={classes.panelDetailsSectionTitle}
        >{`Family child Member Phone Number${
          dependents.length > 1 ? 's' : ''
        }`}</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {dependents.map(dependent => (
            <span className={classes.panelDetailsSectionText}>
              {dependent.phone}&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    )}
    {/* {groupProvider.length > 0 && (
      <div className={classes.panelDetailsSection}>
        <h4 className={classes.panelDetailsSectionTitle}>
          Qwell Concierge Member Of
        </h4>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {groupProvider.map(groupProviders => (
            <span className={classes.panelDetailsSectionText}>
              {groupProviders.fullTitle}&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>
    )} */}
  </>
);

const PatientProfilePage = ({ classes, match, enqueueSnackbar }) => {
  const [loading, setLoading] = useState(true);
  const [patient, setPatient] = useState(true);
  const [isEditMode, setEditMode] = useState(false);
  const [tabPosition, setTabPosition] = useState(0);
  // const { enqueueSnackbar } = useSnackbar();
  const [isAppointmentModalOpen, setAppointmentModalOpen] = useState(false);
  const [isConsultNotesModalOpen, setConsultNotesModalOpen] = useState(false);

  const fetchPatient = async () => {
    const {
      params: { patientId },
    } = match;
    const fetchedPatient = await fetchPatientById(patientId);
    setPatient(fetchedPatient);
    setTimeout(() => setLoading(false), 400);
  };

  const onUpdatePatient = async patient => {
    try {
      const updatedPatient = await updatePatient(patient);
      setLoading(true);
      setPatient(updatedPatient);
      setLoading(false);
      setEditMode(false);
    } catch {
      enqueueSnackbar('Oops, something went wrong. Please Try again');
      setLoading(true);
      fetchPatient();
      setEditMode(false);
    }
  };

  const sendConsultNote = async noteParams => {
    try {
      await createConsultNote(noteParams);
      enqueueSnackbar('Successfully sent note!');
      setConsultNotesModalOpen(false);
    } catch (err) {
      enqueueSnackbar('Unable to send note. Please try again.');
    }
  };

  useEffect(() => {
    fetchPatient();
  }, []);

  return (
    <div className={classes.root}>
      <div className="paddingZero">
        <header className={classes.header}>
          <Grid
            className="custom-xs-container"
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography variant="body1" className={classes.backLink}>
                <RouterLink to="/admin/patients">Back</RouterLink>
              </Typography>
              <Typography variant="h2" className={classes.headerText}>
                Patient Profile
              </Typography>
            </Grid>
          </Grid>
        </header>

        <Grid container className={classes.marginBottomFourtyEight}>
          <AppBar position="static" color="default">
            <Tabs
              value={tabPosition}
              onChange={(_, position) => setTabPosition(position)}
              className="table-tab"
            >
              <Tab label="Profile" />
              <Tab label="Appointments" />
              <Tab label="Requests/Referrals" />
              <Tab label="Doc to Doc Messages" />
              <Tab label="Insurance attachment files" />
              <Tab label="Patient Tracker" />
            </Tabs>
          </AppBar>
          {tabPosition === 0 && (
            <TabPanel>
              {loading ? (
                <CircularProgress className={classes.loading} />
              ) : (
                <Grid container>
                  <Grid item xs={12} md={12} lg={12}>
                    {isEditMode ? (
                      <PatientProfile
                        patient={patient}
                        onSubmit={onUpdatePatient}
                        source="patientProfilePage"
                        onClose={() => {
                          setEditMode(!isEditMode);
                          setTabPosition(0);
                        }}
                        backButtonText="Cancel"
                      />
                    ) : (
                      userInfoForm({
                        classes,
                        ...patient,
                      })
                    )}
                  </Grid>
                </Grid>
              )}
            </TabPanel>
          )}
          {tabPosition === 1 && (
            <TabPanel className={classes.overflowXAuto}>
              <PatientChartAppts patientId={patient.id} />
            </TabPanel>
          )}
          {tabPosition === 2 && (
            <TabPanel className={classes.overflowXAuto}>
              <PatientChartApptReqs patientId={patient.id} />
            </TabPanel>
          )}
          {tabPosition === 3 && (
            <TabPanel className={classes.overflowXAuto}>
              <PatientChartConsultNotes patientId={patient.id} />
            </TabPanel>
          )}
          {tabPosition === 4 && (
            <TabPanel className={classes.overflowXAuto}>
              <PatientsAttachments patientId={patient.id} />
            </TabPanel>
          )}
          {tabPosition === 5 && (
            <TabPanel className={classes.overflowXAuto}>
              <PatientTracker patientId={patient.id} patientInfo={patient} />
            </TabPanel>
          )}
        </Grid>

        <Grid container>
          <Button
            className={`${classes.marginLeftAuto} ${classes.button}`}
            color="primary"
            variant="contained"
            onClick={() => {
              setEditMode(!isEditMode);
              setTabPosition(0);
            }}
            disabled={isEditMode}
          >
            Edit Info
          </Button>
          <Button
            className={`${classes.marginLeftTen} ${classes.button}`}
            color="primary"
            variant="contained"
            onClick={() => setAppointmentModalOpen(true)}
          >
            book/request appointment
          </Button>
          <Button
            className={`${classes.marginLeftTen} ${classes.button}`}
            color="primary"
            variant="contained"
            onClick={() => setConsultNotesModalOpen(true)}
          >
            Message a Doc
          </Button>
        </Grid>

        <BookAppointmentModal
          open={isAppointmentModalOpen}
          patient={patient}
          closeDialog={() => {
            setAppointmentModalOpen(false);
          }}
        />

        <ConsultNoteEditModal
          patient={patient}
          open={isConsultNotesModalOpen}
          save={sendConsultNote}
          onClose={() => {
            setConsultNotesModalOpen(false);
          }}
        />
      </div>
    </div>
  );
};

const styles = () => ({
  overflowXAuto: {
    overflowX: 'auto',
  },
  loading: {
    display: 'block',
    margin: 'auto',
  },
  root: {
    padding: '3em',
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  list: {
    paddingBottom: '2em',
  },
  panelDetailsSection: {
    paddingBottom: '34px',
  },
  panelDetailsSectionTitle: {
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  panelDetailsSectionText: {
    color: '#1C2B39',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '19px',
  },
  marginBottomFourtyEight: {
    marginBottom: 48,
  },
  marginLeftTen: {
    marginLeft: 10,
  },
  marginLeftAuto: {
    marginLeft: 'auto',
  },
  button: {
    marginBottom: 10,
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
    },
  },
  backLink: {
    marginBottom: 15,
  },
});

export default withSnackbar(withStyles(styles)(PatientProfilePage));
